export { default } from "./DatoCmsFullwidthImage";
